import { Link } from 'react-router-dom';
import { news } from '@/mocks/news';
import { categories } from '@/mocks/categories';

const categoryName = (id: string) =>
  categories.find((cat) => cat.id === id)?.shortName ?? '综合';

export default function LatestNewsList() {
  const sorted = [...news].sort((a, b) => (a.date < b.date ? 1 : -1));
  const list = sorted.slice(0, 7);

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="flex items-center justify-between px-4 md:px-5 py-4 border-b border-background-200">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 flex items-center gap-2">
          <i className="ri-newspaper-line text-primary-600 w-5 h-5 flex items-center justify-center" />
          最新赛事资讯
        </h3>
        <span className="text-xs text-foreground-500">按时间倒序</span>
      </div>

      <ul className="divide-y divide-background-200">
        {list.map((item) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.eventId}`}
              className="group block px-4 md:px-5 py-4 hover:bg-background-100/70 transition-colors"
            >
              <div className="flex items-start gap-3">
                <span className="mt-0.5 shrink-0 inline-flex items-center px-2 py-0.5 rounded-full text-[11px] bg-secondary-100 text-secondary-800">
                  {item.tag}
                </span>
                <div className="min-w-0 flex-1">
                  <h4 className="text-sm md:text-[15px] font-medium text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors line-clamp-1">
                    {item.title}
                  </h4>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.summary}
                  </p>
                  <div className="mt-2 flex items-center gap-3 text-[11px] md:text-xs text-foreground-500 flex-wrap">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center" />
                      {item.time}
                    </span>
                    <span className="text-primary-600">{categoryName(item.categoryId)}</span>
                    <span>{item.date}</span>
                  </div>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>

      <div className="px-4 md:px-5 py-3.5 border-t border-background-200 bg-background-100/50">
        <Link
          to="/search"
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 transition-colors"
        >
          查看全部赛事资讯
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
        </Link>
      </div>
    </div>
  );
}